module.exports = __webpack_public_path__ + "static/media/logo.3a9d3d31.jpeg";